import { Bookmark } from './Bookmark';
import { Chart } from './Chart';
import { CustomFilter } from './CustomFilter';
import { Favorite } from './Favorite';
import { Folder } from './Folder';
import { Investment } from './Investment';
import { Pipeline } from './Pipeline';
import { Subteam } from './Subteam';
import { Teammate } from './Teammate';
import { TeamResourceAccess } from './TeamResourceAccess';
import { User } from './User';
import { Workspace } from './Workspace';

export enum TeamVisibilityType {
    PRIVATE = 'Private',
    SHARED = 'Shared',
    WORKSPACE = 'Workspace',
}

export interface Team {
    id: string;
    workspace: Workspace;
    user: User;
    teammates: Teammate[];
    subteams?: Subteam[];
    resourceAccess?: TeamResourceAccess[];
    visibility: TeamVisibilityType | undefined;
    folders: Folder;
    investments: Investment;
    bookmarks: Bookmark;
    pipelines: Pipeline;
    customFilters: CustomFilter;
    charts: Chart;
    favorited: boolean;
    locked: boolean;
    archived: boolean;
    favorites: Favorite;
    name: string;
    handle: string | undefined;
    description: string;
    emoji: string;
    background: string;
    deletedAt?: Date | string | null;
    createdAt: Date;
    updatedAt: Date;
    teammateCount?: number;
    subteamCount?: number;
    resourceAccessCount?: number;
    joined?: boolean;
    canJoin?: boolean;
}
